import * as React from 'react'

import { Button, Radio } from '@factorialco/deprecated-design-system'
import { FormikProps } from 'formik'
import { isEmpty } from 'lodash'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { FormData } from 'modules/attendance/lib/forms/TimeBlocksSupplementForm'

export interface Props {
  form: FormikProps<FormData>
  onSubmit: () => void
  onCancel: () => void
}

const PayrollPeriod = ({ form, onSubmit, onCancel }: Props) => {
  return (
    <Modal
      title={i18n.t('clock_in.sidepanel.compensation.modal.payroll_period.title')}
      description={i18n.t('clock_in.sidepanel.compensation.modal.payroll_period.description')}
      illustration="monety-bag"
      onSubmit={() => {
        form.handleSubmit()
        if (isEmpty(form.errors)) {
          onSubmit()
        }
      }}
      onClose={onCancel}
      footer={
        <>
          <Button onClick={onCancel} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>
            {i18n.t('time_tracking.modals.compensation.payroll.create.submit')}
          </Button>
        </>
      }
    >
      <Radio.Wrap>
        <Radio
          name={i18n.t('time_tracking.modals.compensation.payroll.create.current_period.name')}
          value={form.values.period}
          onChange={(value) => form.setFieldValue('period', value)}
          description={i18n.t(
            'time_tracking.modals.compensation.payroll.create.current_period.description'
          )}
          option={{
            label: i18n.t('time_tracking.modals.compensation.payroll.create.current_period.name'),
            value: 'current',
          }}
        />
      </Radio.Wrap>
      <Radio.Wrap>
        <Radio
          name={i18n.t('time_tracking.modals.compensation.payroll.create.next_period.name')}
          value={form.values.period}
          onChange={(value) => form.setFieldValue('period', value)}
          description={i18n.t(
            'time_tracking.modals.compensation.payroll.create.next_period.description'
          )}
          option={{
            label: i18n.t('time_tracking.modals.compensation.payroll.create.next_period.name'),
            value: 'next',
          }}
        />
      </Radio.Wrap>
    </Modal>
  )
}

export default PayrollPeriod
